import { IOption } from 'common/ui/interfaces/selectors';
import { DriverLicenseTypeEnum } from '../enums/driver-license-type.enum';

export const DriverLicenseTypeLabel = {
  [DriverLicenseTypeEnum.CLASS_A]: 'CDL-A',
  [DriverLicenseTypeEnum.CLASS_B]: 'CDL-B',
  [DriverLicenseTypeEnum.CLASS_C]: 'CDL-C',
  [DriverLicenseTypeEnum.CLASS_D]: 'D',
  [DriverLicenseTypeEnum.CLASS_E]: 'E',
  [DriverLicenseTypeEnum.CLASS_M]: 'M',
  [DriverLicenseTypeEnum.NON_CDL]: 'NONE',
};

export const DriverLicenseTypeOptions: IOption[] = Object.entries(
  DriverLicenseTypeLabel
).map(([value, label]: [string, string]) => ({ value, label }));
